<template>
    <div>
        <form autocomplete="off" @submit.prevent="postAsignarBecas()">
            <vs-row class="p-4">
                <vs-col w="12" class="lineTitulo mb-2">
                    <h5><strong>ASIGNAR BECAS</strong></h5>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Ciclo escolar</label>
                    <vs-select
                        :loading="loadingCiclo"
                        filter
                        class="pt-0"
                        placeholder="Ciclo escolar" 
                        v-model="cicloEscolar"
                        :key="cicloEscolarId" 
                    >
                        <vs-option v-for="(opcion, i) in cicloEscolares" :key="i" :label="opcion.text" :value="opcion.id">
                            {{opcion.text}}
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col class="inputTitulo" sm="12" lg="4">
                    <label>Becas</label>
                    <vs-select
                        filter
                        class="pt-0"
                        placeholder="Becas" 
                        v-model="beca"
                        :key="becaId"
                        :loading="loadingBecas"
                        :disabled="!becas.length"
                    >
                        <vs-option v-for="(opcion, i) in becas" :key="i" :label="opcion.text" :value="opcion.id">
                            {{opcion.text}}
                        </vs-option>
                        <template #message-danger v-if="errorFields.includes('beca')">
                            Requerido
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col w="12" class="mt-2 d-flex">
                    <vs-button
                        success
                        type="submit"
                        class="ml-auto"
                    >
                        Guardar
                    </vs-button>
                </vs-col>
                <vs-col>
                <vs-table striped>
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 25%">
                                Beca
                            </vs-th>
                            <vs-th style="width: 25%">
                                Estatus
                            </vs-th>
                            <vs-th style="width: 25%">
                                Ciclo escolar
                            </vs-th>
                            <vs-th style="width: 25%">
                                Comentario
                            </vs-th>
                            <vs-th style="width: 25%">
                                Acciones
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in becas_asignadas"
                            :data="tr"
                        >
                            <vs-td>
                                {{ tr.beca }}
                            </vs-td>
                            <vs-td>
                                <md-chip class="mb-1 fontMedium mini-chip" :class="colorEstatus[tr.status]" ><strong class="text-uppercase"> {{tr.status}}</strong></md-chip>
                            </vs-td>
                            <vs-td>
                                {{ tr.ciclo }}
                            </vs-td>
                            <vs-td>
                                {{ tr.comentario }}
                            </vs-td>
                            <vs-td>
                                <div  @click="activeEditar =! activeEditar, selectBeca = tr">
                                    <div class="botonEditar">
                                       <i class="fas fa-edit"></i>
                                    </div>
                                </div>
                            </vs-td>
                        </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
        </form>
        <editar-beca v-model="activeEditar" :selectBeca="selectBeca" :csrf_token="csrf_token" @refreshTableBeca="getBecasAsignadas" :institucion_id_url="institucion_id_url"></editar-beca>
    </div>
</template>
<script>
import alumnos from '../../../../../api/requests/alumno'
import EditarBeca from './modales/editar.vue'
export default {
    props: [
        'general',
        'csrf_token',
        'institucion_id_url'
    ],
    data(){
        return{
            cicloEscolar:'',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            beca: '',
            becas: [],
            becaId: (new Date()).getTime(),
            loadingBecas: false,
            becas_asignadas: [],
            errorFields: [],
            activeEditar: false,
            selectBeca: [],
            colorEstatus: {
                'activa': 'col-green',
                'inactiva': 'col-red'
            },
            loadingCiclo: false
        }
    },
    components: {
        EditarBeca
    },
    methods: {
        async getCicloEscolares(){
            try{
                this.loadingCiclo = true
                const { data: response } = await alumnos.getCicloEscolares(this.institucion_id_url)
                this.cicloEscolares = response
                this.cicloEscolarId = (new Date()).getTime()
                this.loadingCiclo = false
            }catch{

            }
        },
        async getBecas(){
            try{
                this.beca = ''
                this.loadingBecas = true
                const { data: response } = await alumnos.getBecas(this.general.datos.persona_id, this.institucion_id_url, this.cicloEscolar)
                this.becas = this.getEliminarNameKey(response)
                this.loadingBecas = false
                this.becaId = (new Date()).getTime()
            }catch{
                this.loadingBecas = false
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        async getBecasAsignadas(){
            if(this.general.datos.persona_id){
                try{
                    const { data: response } = await alumnos.getBecasAsignadas(this.general.datos.persona_id, this.institucion_id_url, this.cicloEscolar ? this.cicloEscolar : 'undefined')
                    this.becas_asignadas = response
                }catch{
                    this.loadingBecas = false
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar){
                this.errorFields.push('cicloEscolar')
            }
            if (!this.beca){
                this.errorFields.push('beca')
            }
            if (!this.errorFields.length){
                
                const params = {
                    ciclo_escolar_id: this.cicloEscolar,
                    institucion_id: this.institucion_id_url,
                    beca_id: this.beca,
                }
                return params
            } else {
                return null
            }
        },
        async postAsignarBecas(){
            if(this.sanityForm()){
                this.errorFields = []
                const loading = this.$vs.loading()
                try{
                    const {data: response} = await alumnos.postAsignarBecas(this.general.datos.persona_id, this.sanityForm())
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.beca = ''
                    this.getBecasAsignadas()
                }catch(error){
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: error.response.data.errores.descripcion
                    })
                }
            }
        },
    },
    watch:{
        general(){
            this.getCicloEscolares()
            this.getBecasAsignadas()
        },
        cicloEscolar(){
            this.getBecas()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
<style scoped>
.col-green{
    color: #55ce63;
    background: rgb(232, 253, 235);
}
.col-red{
    color: #f62d51;
    background: rgb(249, 231, 235);
}
</style>
